// Keys held down right now, for the camera's arrow-key panning. Camera keys are
// the one exception to shortcuts.ts's rule that every key presses a button:
// panning has its on-screen equivalent in dragging. Only the arrows pan: W and A
// are the Smoke screen's and Auto's shortcuts, and a pan key never reaches a button.
import { ignoreKey } from './shortcuts.ts';

const held = new Set<string>();

/** Keys that pan the camera, as e.code so they work on any keyboard layout. */
const PAN: Record<string, [number, number]> = {
  ArrowUp: [0, 1], ArrowDown: [0, -1], ArrowLeft: [1, 0], ArrowRight: [-1, 0],
};

export function isPanKey(e: KeyboardEvent): boolean {
  return e.code in PAN && !ignoreKey(e);
}

export function isHeld(code: string): boolean {
  return held.has(code);
}

window.addEventListener('keydown', e => {
  // a pan key pressed while typing in a field types; it does not pan
  if (e.code in PAN && ignoreKey(e)) return;
  held.add(e.code);
});
window.addEventListener('keyup', e => { held.delete(e.code); });
// a key released while the window was not looking would otherwise pan forever
window.addEventListener('blur', () => held.clear());

/** Screen pixels per second the camera moves while a pan key is held. */
const PAN_SPEED = 900;

/** The camera move for this frame from the held pan keys, in screen pixels. */
export function panStep(deltaMS: number): [number, number] {
  let dx = 0, dy = 0;
  for (const code of held) {
    const d = PAN[code];
    if (d) { dx += d[0]; dy += d[1]; }
  }
  if (dx === 0 && dy === 0) return [0, 0];
  const l = Math.hypot(dx, dy), k = (PAN_SPEED * deltaMS) / 1000 / l;
  return [dx * k, dy * k];
}
